<div id="courier-information-section">
    <h1>{{ 'dashboard.courierInformation.title' | translate }}</h1>

    @if (courierPickupDetails()) {
        <div>
            <p>
                {{ 'dashboard.courierInformation.description' | translate }}
            </p>
            @if (!isLoading()) {
                <div class="courier-description-card">
                    <p class="courier-name">{{ courierPickupDetails()?.courierName }}</p>
                    <p>
                        <span class="label">{{ 'dashboard.courierInformation.pickUpDays' | translate }}: </span>
                        <span>{{
                            (courierPickupDetails()?.establishedCourierOrganization
                                ? 'dashboard.courierInformation.freeCourier.pickupDays'
                                : 'dashboard.courierInformation.paidCourier.pickupDays'
                            ) | translate
                        }}</span>
                    </p>
                    <p>
                        <span class="label">{{ 'dashboard.courierInformation.requestCutoffTime' | translate }}: </span>
                        <span>{{ courierPickupDetails()?.requestCutoffTime }}</span>
                    </p>
                    <p>
                        <span class="label">{{ 'dashboard.courierInformation.dropboxCutoffTime' | translate }}: </span>
                        <span>{{ courierPickupDetails()?.dropboxCutoffTime }}</span>
                    </p>
                    <p-button
                        id="schedule-pick-up-button"
                        size="small"
                        [label]="'dashboard.courierInformation.scheduleButton' | translate"
                        [outlined]="true"
                        (click)="onOpenScheduleCourierPickUp.emit()"></p-button>
                </div>
            } @else {
                <app-loader></app-loader>
            }
        </div>
    } @else {
        <p id="no-courier-assigned" [innerHTML]="'dashboard.courierInformation.noCourierAssigned' | translate"></p>
    }
</div>
